/**
 * Shared rotation option metadata used by the location display settings UI,
 * message request grouping, and display player labels.
 *
 * Values are degrees as defined by the API (-179..180). The current four
 * supported orientations are 0, -90 (left), 90 (right), and 180 (upside down).
 */

export const ROTATION_NOT_ROTATED = 0;
export const ROTATION_LEFT = -90;
export const ROTATION_RIGHT = 90;
export const ROTATION_UPSIDE_DOWN = 180;

/**
 * Canonical option list (order matches the design spec).
 */
export const ROTATION_OPTIONS = [
  {
    value: ROTATION_NOT_ROTATED,
    label: 'Not Rotated',
    shortLabel: 'Not Rotated',
  },
  {
    value: ROTATION_LEFT,
    label: 'Left',
    shortLabel: 'Rotated Left',
  },
  {
    value: ROTATION_RIGHT,
    label: 'Right',
    shortLabel: 'Rotated Right',
  },
  {
    value: ROTATION_UPSIDE_DOWN,
    label: 'Upside Down',
    shortLabel: 'Upside Down',
  },
];

/**
 * Translate a rotation degree value to its short display label.
 * Falls back to an empty string when not rotated or unknown.
 */
export function rotationLabel(deg) {
  const match = ROTATION_OPTIONS.find(option => option.value === deg);

  if (!match || match.value === ROTATION_NOT_ROTATED) {
    return '';
  }

  return match.shortLabel;
}

/**
 * Translate a rotation degree value to its full descriptive label.
 */
export function rotationFullLabel(deg) {
  const match = ROTATION_OPTIONS.find(option => option.value === deg);
  return match ? match.label : '';
}

/**
 * Whether a rotation value represents a portrait orientation.
 * Useful for downstream consumers that still need orientation-style flags
 * (e.g. aspect ratio comparisons).
 */
export function isPortraitRotation(deg) {
  return deg === ROTATION_LEFT || deg === ROTATION_RIGHT;
}

export default ROTATION_OPTIONS;
